import { Link } from 'react-router-dom'
import classes from './TextCell.module.css'
import classesCell from './BodyCell.module.css'
import { isPersonAMinor } from '../../../lib/script'
import Tag from '../../fragments/Tag'

const TextCellLink = ({text, special, group, item}) => {
    return <div className={`${classes.text_cell} ${classesCell.body_cell}`}>       
       {/* <Link to={`/details/${item.case.id}`}>{text ? text : '-'}</Link> */}
       <Link to={`/details/${item.patient.person_number}`}>{text ? text : '-'}</Link>
        {special && special == 'dob' && <>{isPersonAMinor(group?.dob) && <Tag>Minor</Tag>}</>}
    </div>
}

export default TextCellLink